export default __webpack_public_path__ + "static/media/SDA_logo.bd7d0601.svg";